module.exports = __webpack_public_path__ + "static/media/randomMaze.80fbc83d.gif";